import React from 'react';
import { useState } from 'react';
import Axios from 'axios';
import Cookies from 'js-cookie';
import Resizer from 'react-image-file-resizer';

const Login = (props) => {
    const [isloginForm, setIsLoginForm] = useState(false);
    const [name, setName] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [valid, setValid] = useState(false);
    const [message, setMessage] = useState('');
    const [disable, setDisable] = useState(false);
    const [bio, setBio] = useState('');
    const [image, setImage] = useState(null);
    const [afterSignup, setAfterSignup] = useState(false);
    const [profileUploadDisable, setProfileUploadDisable] = useState(false);
    const [userID, setUserID] = useState(undefined);
    const checkValid = () => {
        if (!isloginForm) {   //for sign up
            if (name.length == 0 || password.length == 0 || confirmPassword.length == 0) {
                setValid(false);
                setMessage('');
            }
            else if (name.length < 7) {
                setValid(false);
                setMessage('It is not your real/Full name -_-');

            }
            else if (name.length > 20) {
                setValid(false);
                setMessage('It is a too long name -_-');
            }
            else if (password.length < 5) {
                setValid(false);
                setMessage('Password too short..')
            }
            else if (password !== confirmPassword) {
                setValid(false);
                setMessage('confirm password mismatched..')
            }
            else {
                setValid(true)
                setMessage('Please wait.....')
                setDisable(true);
                // console.log('hiiiiiiiiiiiiiiii')
                Axios.post("https://conffesion.herokuapp.com/login", { name: name, password: password, fromLogin: isloginForm, bio: bio })
                    .then(res => {
                        if (res.data.success) {

                            setAfterSignup(true);
                            // props.setIsLogin(true)
                            setMessage(res.data.message);
                            // setDisable(false);
                            Cookies.set('islogintemp', 1);
                            Cookies.set('name', name, { expires: 100 });
                            Cookies.set('userID', res.data.userID, { expires: 100 });
                            Cookies.set('password', password, { expires: 100 });
                            setUserID(res.data.userID);
                        } else {
                            setMessage(res.data.message);
                            setDisable(false);
                        }
                        setTimeout(() => {
                            window.location.reload();
                        }, 2000);
                    }).catch(err => { setMessage(err); setDisable(false) })
            }
        }
        else { //for log in
            if (name.length < 7) {
                setValid(false);
                setMessage('Invalid')
            } else if (password.length < 5) {
                setValid(false);
                setMessage('Invalid')
            } else {
                setValid(true)
                setMessage('Please wait.....')
                setDisable(true);
                Axios.post("https://conffesion.herokuapp.com/login", { name: name, password: password, fromLogin: isloginForm })
                    .then(res => {
                        if (res.data.success) {
                            props.setIsLogin(true)
                            setMessage(res.data.message);
                            Cookies.set('islogintemp', 1);
                            Cookies.set('name', name, { expires: 100 });
                            Cookies.set('userID', res.data.userID, { expires: 100 });

                            Cookies.set('password', password, { expires: 100 });
                            setTimeout(() => {
                                window.location.reload();
                            }, 2000);
                        } else {
                            setMessage(res.data.message);
                            setDisable(false)
                        }

                    }).catch(err => { setMessage(err); setDisable(false) })
            }
        }
    }

    const onSubmitHandler = (e) => {
        e.preventDefault();
        checkValid();
    }
    const posUploadHandler = (event) => {
        setImage(
            // selectedImage: URL.createObjectURL(event.target.files[0])
            event.target.files[0],

        )
        var fileInput = false
        if (event.target.files[0]) {
            fileInput = true
        }

        if (fileInput) {
            // var userId = Cookie.get('userId');
            // var password = Cookie.get('password');
            Resizer.imageFileResizer(
                event.target.files[0],
                196,
                257,
                'JPEG',
                80, //quality
                0,//rotation
                uri => {//////////////////////////////uploading profilepic
                    // console.log(uri)
                    setImage(uri)
                    setProfileUploadDisable(true);
                    setMessage('Uploading......')
                    Axios.post('https://conffesion.herokuapp.com/postProfilePic', { uploadImage: uri, userID: userID })
                        .then(res => {
                            setMessage('Successfully uploaded!');
                            setTimeout(() => {
                                props.setIsLogin(true)
                            }, 500);
                        })
                        .catch(err => { props.setIsLogin(true) })
                },
                'base64'
            );
        }
    }

    const loginForm = () => {
        return (
            <div>
                <form onSubmit={(e) => onSubmitHandler(e)} >
                    <div class="form-group">
                        <label for="email">Name:</label>
                        <input type="name" class="form-control" id="name" placeholder="Your Full name" name="name" value={name} onChange={(e) => setName(e.target.value)} />
                    </div>
                    <div class="form-group">
                        <label for="pwd">Password:</label>
                        <input type="password" class="form-control" id="pwd" placeholder="Enter password" name="pswd" value={password} onChange={(e) => setPassword(e.target.value)} />
                    </div>
                    <button type="submit" class="btn btn-primary" disabled={disable}>Login</button>
                </form>
                <button className='btn btn-link' disabled={disable} onClick={() => setIsLoginForm(false)}>Just kidding XD I dont have an account!</button>

            </div>
        )
    }
    const signupForm = () => {
        return (
            <div>
                <form onSubmit={onSubmitHandler}>
                    <div class="form-group">
                        <label>Name:</label>
                        <input type="name" class="form-control" id="name" placeholder="Your Full name" name="name" value={name} onChange={(e) => setName(e.target.value)} />
                    </div>
                    <div class="form-group">

                        <input type="text" class="form-control" id="name" placeholder="Somthing about you (bio)" name="bio" value={bio} onChange={(e) => setBio(e.target.value)} />
                    </div>
                    <div class="form-group">
                        <label for="pwd">Password:</label>
                        <input type="password" class="form-control" id="pwd" placeholder="Enter password" name="pswd" value={password} onChange={(e) => setPassword(e.target.value)} />
                    </div>
                    <div class="form-group">
                        <input type="password" class="form-control" id="pwd" placeholder="confirm password" name="pswd" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} />
                    </div>
                    <button type="submit" class="btn btn-primary" disabled={disable}>Sign up</button>
                </form>
                <button className='btn btn-link' disabled={disable} onClick={() => setIsLoginForm(true)}>Already have an Account?</button>
            </div>
        )
    }
    const signupForm2 = () => {
        return (
            <div className='card'>
                <div className='btn btn-primary' disabled={profileUploadDisable} onClick={() => { document.getElementById("imageInput_post").click() }}>Set profile picture</div>
                <input type="file" name="filetoupload" id="imageInput_post" accept="image/*" hidden onChange={(e) => posUploadHandler(e)}></input>

            </div>
        )
    }
    return (
        <div>
            {message.length ? (<p>{message}</p>) : (<p></p>)}
            {
                isloginForm ? (loginForm()) : (signupForm())
            }
            {
                afterSignup ? (signupForm2()) : ('')
            }
        </div>
    )
}
export default Login;